import Vue from 'vue'
import App from './App.vue'

import VueI18n from 'vue-i18n';
const data = require('./message.json');

Vue.config.productionTip = false

// 言語の設定
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'ja', 
    messages: data
});

new Vue({
    i18n: i18n,    
    render: h => h(App),
}).$mount('#app')
